module.exports = __webpack_public_path__ + "static/metal-frame08-6161947e8231a240c25dded366c8367c.jpg";